import * as Sentry from "@sentry/react";
import type BankAccountBlacklist from "entities/bankAccountBlacklist";
import type BankAccountBlacklistRepository from "repositories/bankAccountBlacklistRepository";
import type RefundsDisapprovalViewModel from "viewModels/finance/bankAccountBlacklists/refundsDisapprovalViewModel";
import type LocalizationService from "./localizationService";
import type ModalService from "./modalService";

export default class RefundDisapprovalService {
  constructor(
    private localizationService: LocalizationService,
    private modalService: ModalService,
    private repository: BankAccountBlacklistRepository,
    private refundsDisapprovalViewModelFactory: ReturnType<typeof RefundsDisapprovalViewModel.Factory>
  ) {}

  async disapproveWithConfirmation(bankAccountBlacklist: BankAccountBlacklist) {
    const confirmed = await this.showConfirmation(bankAccountBlacklist);
    let dissapproved = false;

    if (confirmed) {
      try {
        await this.repository.disapproveAllRefunds(bankAccountBlacklist);
        dissapproved = true;
      } catch (error) {
        Sentry.captureException(error);
      }
    }

    return dissapproved;
  }

  private async showConfirmation(bankAccountBlacklist: BankAccountBlacklist) {
    const refunds = await this.repository.getAllApprovedRefunds(bankAccountBlacklist);
    let result = true;

    if (refunds.items.length > 0) {
      const viewModel = this.refundsDisapprovalViewModelFactory(refunds.items);
      await this.modalService.tryActivateChild(viewModel);
      result = await viewModel.showConfirmation();
      this.modalService.closeChild(viewModel);
    }

    return result;
  }
}
